import Button from 'react-bootstrap/Button'
import ArrowIcon from '@/components/elements/icons/ArrowIcon'
import { useTranslation } from 'next-i18next'

interface Props {
  onClick: () => void
  disabled: boolean
}

const StartBookingButtonLead = ({ onClick, disabled }: Props) => {
  const { t } = useTranslation('common')

  return (
    <Button onClick={onClick} variant={'signal'} className="w-100 an-wobble-horizontal-trigger fs-4" disabled={disabled}>
      <ArrowIcon fontsize={'5rem'} className={'me-2'} />
      {t('booking.next')}
    </Button>
  )
}

export default StartBookingButtonLead
